import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Heading from "UI/Heading";

import MediaCard from "../components/MediaCard";
import Container from '../components/Container';
import UploadDialog from "../components/UploadDialog";
import UploadButton from "../components/UploadButton/UploadButton";
import BlankMediaList from "../components/BlankStates/BlankMediaList";
import MediaCardSkeleton from '../components/Skeletons/MediaCardSkeleton';
import Photograph from "UI/Heroicons/Photograph";
import BlankMedia from "Components/BlankStates/BlankMedia";

class MediaController extends React.Component
{
    state = {
        showUploadModal: false
    };

    static propTypes = {
        loading: PropTypes.bool.isRequired
    };

    render()
    {
        const { classes } = this.props;

        const actions = <UploadButton onClick={() => this.setState({showUploadModal: true})} />;

        const title = <div className='flex'>
            <Photograph className='w-7 mr-3' />Media
        </div>;

        return <Container>
            <Heading
                title={title}
                description='Upload your images. These can then be included when you create a story.'
                actions={actions} />

            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6'>
                { this.props.loading && <MediaCardSkeleton /> }
                {
                    this.props.media.map(file => <MediaCard key={file.id} file={file} />)
                }
            </div>

            { this.renderBlankState() }

            <UploadDialog
                open={this.state.showUploadModal}
                onClose={() => this.setState({showUploadModal: false})}
                multiple
            />
        </Container>;
    }

    renderBlankState()
    {
        if (this.props.loading) {
            return null;
        }

        if (this.props.media.length > 0) {
            return null;
        }

        return <div className='relative'>
            <BlankMedia className='text-gray-600 absolute right-0 mr-12 -mt-12 w-64' />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    media: _.filter(state.media, ['accountId', state.currentAccountId]),
});

export default connect(mapStateToProps)(MediaController);
